"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useCurrentPageContent = _interopRequireDefault(require("../hooks/app/useCurrentPageContent"));
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StickyFooterWrapper = (0, _styledComponents.default)(_core.DialogActions)`
  display: block !important;
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 1000;
  && {
    justify-content: center;
  }
  div {
    flex: 1;
  }
`;

// const FooterWrapper = styled.div`
//   padding-top: 1.6%;
//   background-color: #fff;
//   margin-top: -1px;
//   & [class*='GridColumnstyle__GridColumn'] {
//     box-sizing: border-box;
//   }
// `;
const StickyFooter = () => {
  const {
    footer
  } = (0, _useCurrentPageContent.default)();
  const showStickyFooter = (0, _useConfig.default)('uiSettings.showStickyFooter', false);
  if (!showStickyFooter || !footer) return null;
  return /*#__PURE__*/_react.default.createElement(StickyFooterWrapper, {
    className: "gs-app"
  }, footer);
};
var _default = StickyFooter;
exports.default = _default;